/**
 * Total TTC checkout / panier (remise promo + livraison, plancher à 0).
 */
export function computeCheckoutTotal(subtotal, promoDiscount = 0, shippingCost = 0) {
  const sub = Number(subtotal) || 0;
  const discount = Number(promoDiscount) || 0;
  const shipping = Number(shippingCost) || 0;
  return Math.max(0, sub - discount + shipping);
}
